import { makeStyles } from '@mui/styles';
const loaderStyles = makeStyles(({ palette }) => ({
    loaderDot: {
        color: palette.primary.main,
        animationName: '$loader',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        padding: '0 2px 0 2px',
    },
    loaderDot1: {},
    loaderDot2: {
        animationDelay: '0.5s',
    },
    loaderDot3: {
        animationDelay: '1s',
    },
    '@keyframes loader': {
        '0%': {
            opacity: 0.1,
        },
        '50%': {
            opacity: 1,
        },
        '100%': {
            opacity: 0.1,
        },
    },
}));
export default loaderStyles;
//# sourceMappingURL=dotsLoader.styles.js.map